// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"92285650","281":"05b2e954","352":"a9392331","659":"6a56b35d","722":"646f8712","794":"247a8831","811":"5cb4f2e8","927":"74450b0d","952":"54232475"}[chunkId] + ".chunk.js";
};